import Vue from 'vue';
import Router from 'vue-router';
import Index from './components/index/Index';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: '',
  linkActiveClass: '',
  scrollBehavior(to, from, savedPosition) {
    $('html, body').animate({
      scrollTop: 0
    }, 100);
  },
  routes: [
    {
      path: '/menyu',
      name: 'Menu',
      component: Index,
      children: [
        {
          path: ':category',
          component: Index,
          name: 'MenuInside'
        }
      ]
    },
    {
      path: '/fotootchety',
      name: 'PhotoReports',
      component: Index,
      children: [
        {
          path: ':item',
          component: Index,
          name: 'PhotoReportsInside'
        }
      ]
    },
    {
      path: '/anonsy',
      name: 'Announce',
      component: Index,
      children: [
        {
          path: ':item',
          component: Index,
          name: 'AnnounceInside'
        }
      ]
    },
    {
      path: '/korzina',
      name: 'Cart',
      component: Index,
      children: [
        {
          path: ':step',
          component: Index,
          name: 'CartStep'
        }
      ]
    },

    {
      path: '*',
      name: 'Index',
      component: Index
    }
  ]
})
